import { render, staticRenderFns } from "./ResumeList.vue?vue&type=template&id=4b7a90fa&scoped=true&"
import script from "./ResumeList.vue?vue&type=script&lang=js&"
export * from "./ResumeList.vue?vue&type=script&lang=js&"
import style0 from "./ResumeList.vue?vue&type=style&index=0&id=4b7a90fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a90fa",
  null
  
)

export default component.exports